require('angular')
require('angular-route')
require('angular-ui-map')

require('../../core/translation/translation-module')
require('../components/flash/flash-module')
require('../components/error-handler/error-handler-module')
require('../components/common-wrapper/common-wrapper-module')
require('../components/form/form-module')
require('../components/animate/animate-module')
require('../components/account/account-module')
require('../components/auth/auth-module')

#load Templates
require('./list-request.jade')
require('./index.jade')
require('./list-member.jade')

# Load Css
require('../../../sass/web/html/_group_members_list_request.scss')
require('../../../sass/web/html/_group_members_list.scss')


GroupListMemRequestCtrl = require('./group-list-mem-request-controller')
GroupListMembersPmCtrl = require('./group-list-member-permission-controller')
GroupListMembersCtrl = require('./group-list-member-controller')
GroupMemberService = require('./group-member-service')
GroupMemPermissionDirective = require('./group-mem-permission-directive/group-mem-permission-directive')
GroupMemberDirective = require('./group-mem-directive/group-mem-directive')

modules = [
  'ngRoute'
  'gnp-translation'
  'gnp-common-wrapper'
  'gnp-remote-api'
  'gnp-form'
  'gnp-flash'
  'gnp-animate'
  'gnp-error-handler'
]

angular.module 'gnp-app-group-member', modules
  .config ['$routeProvider', '$translateProvider', ($routeProvider, $translateProvider) ->
    $translateProvider
      .translations 'en', require('./i18n/en')
      .translations 'ja', require('./i18n/ja')
  ]
  .controller 'GroupListMemRequestCtrl', GroupListMemRequestCtrl
  .controller 'GroupListMembersPmCtrl' , GroupListMembersPmCtrl
  .controller 'GroupListMembersCtrl', GroupListMembersCtrl
  .directive 'groupMemPermission' , GroupMemPermissionDirective
  .directive 'groupMember' , GroupMemberDirective
  .factory 'GroupMemberService', GroupMemberService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/group-member/group-member-module.coffee